import Vue from 'vue'
import App from './App.vue'
import vuetify from '@shared/plugins/vuetify';
import router from './router'
import Changelog from '@shared/components/Changelog.vue'
import PageHeader from '@shared/components/PageHeader.vue'
import ProjInfo from '@shared/components/ProjInfo.vue'
import InstallInfo from '@shared/components/InstallInfo.vue'
import Header from '@shared/components/Header'
import Footer from '@shared/components/Footer'
import ProjectBlock from '@shared/components/ProjectBlock'

Vue.component("Changelog", Changelog);
Vue.component("ProjInfo", ProjInfo);
Vue.component("InstallInfo", InstallInfo);
Vue.component("PageHeader", PageHeader);
Vue.component("Header", Header);
Vue.component("Footer", Footer);
Vue.component("ProjectBlock", ProjectBlock);

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
